import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { TextField, FormHelperText } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import { useState } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import submitData from "../submitData";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import api from "../../../store/api";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Alert from "@material-ui/lab/Alert";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import MedicationAutocomplete from "./MedicationAutocomplete";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    fontSize: 16,
    color: "#4A4A4A",
    padding: theme.spacing(0, 0, 1, 0),
  },
  helpText: {
    color: "red",
    padding: theme.spacing(0, 0, 0, 2),
  },
  minWidthText: {
    minWidth: 110,
  },
  medicationRow: {
    paddingLeft: 25,
    paddingBottom: 10,
  },
  headingAlert: {
    padding: theme.spacing(0, 0, 2, 0),
    marginTop: 20,
    width: "100%",
  },
  dateTimePicker: {
    "& h3": {
      fontSize: "3rem",
    },
    "& h4": {
      fontSize: "2rem",
    },
    "& button": {
      minWidth: 0,
    },
    "& input": {
      fontSize: "14px",
    },
  },
}));

export interface Medication {
  dateAndTime: string | null;

  name: string | null;
  dose?: string;
  route?: number;
  unit?: number;
}

interface MedicationInternal {
  dateAndTimeObject?: Date | null;
  dateAndTime: string | null;
  name: string | null;
  brandId?: string | null;
  monographId?: string | null;
  monographType?: number | null;
  dose?: string;
  unit?: number;
  route?: number;
  errors?: { [index: string]: string };
}

interface SelectItem extends React.Props<any> {
  text: string | undefined;
  value: string | undefined;
  selected: boolean;
}

const Medications = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch }: any) => {
  const createDefaultEmptyList = (length: number): MedicationInternal[] => {
    let result: MedicationInternal[] = [];
    if (length > 0) {
      let i = 1;
      for (; i <= length; i++) {
        result.push({
          dateAndTime: null,
          dateAndTimeObject: null,
          name: null,
        });
      }
    }
    return result;
  };

  const classes = useStyles();

  const [medications, setMedications] = useState<MedicationInternal[]>(createDefaultEmptyList(4));
  const [medicationRoutes, setMedicationRoutes] = useState<SelectItem[]>([]);
  const [medicationUnits, setMedicationUnits] = useState<SelectItem[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const history = useHistory();

  const handleNext = async (): Promise<void> => {
    let _tempMedications = [...medications];
    _tempMedications.forEach((e) => {
      delete e.errors;
      delete e.dateAndTimeObject;
    });
    let _finalMedications = _tempMedications.filter((e) => e.name !== "" && e.name !== null && e.dateAndTime !== null);
    handleData({ MedicalConditions: _finalMedications });
  };

  React.useEffect(() => {
    loadData();
  }, [data]);

  const loadData = async (): Promise<void> => {
    let dateUtil = new DateFnsUtils();
    await getMeidcationRoutes();
    await getMeidcationUnits();
    if (data && data.MedicalConditions && data.MedicalConditions.length > 0) {
      let items = [...data.MedicalConditions] as MedicationInternal[];

      items.forEach((i) => {
        if (i.dateAndTime) {
          i.dateAndTimeObject = i.dateAndTime ? dateUtil.parse(i.dateAndTime, "yyyy-MM-dd'T'HH:mm:ss") : null;
        }
      });
      setMedications(items);
    }
    if (data && data.medicalConditions && data.medicalConditions.length > 0) {
      let items = [...data.medicalConditions];

      items.forEach((i) => {
        if (i.dateAndTime) {
          i.dateAndTimeObject = dateUtil.parse(i.dateAndTime, "yyyy-MM-dd'T'HH:mm:ss");
        }
      });
      setMedications(items);
    }
  };
  const getMeidcationRoutes = async (): Promise<void> => {
    try {
      const medicationRoutes = localStorage.getItem("medicationRoutes");
      if (medicationRoutes) {
        setMedicationRoutes(JSON.parse(medicationRoutes));
      } else {
        const res = await api.getRoutes("");
        localStorage.setItem("medicationRoutes", JSON.stringify(res.data.model));
        setMedicationRoutes(res.data.model ?? []);
      }
    } catch {}
  };

  const getMeidcationUnits = async (): Promise<void> => {
    try {
      const medicationUnits = localStorage.getItem("medicationUnits");
      if (medicationUnits) {
        setMedicationUnits(JSON.parse(medicationUnits));
      } else {
        const res = await api.getMedicationUnits("");
        localStorage.setItem("medicationUnits", JSON.stringify(res.data.model));
        setMedicationUnits(res.data.model ?? []);
      }
    } catch {}
  };

  const saveChanges = async (update = false) => {
    if (!validateForOxygen()) return false;

    var medicationsData = [...medications];
    medicationsData.forEach((e) => {
      delete e.errors;
    });
    medicationsData = medicationsData.filter((e) => e.name !== "" && e.name !== null && e.dateAndTimeObject !== null);

    handleData({ medicalConditions: medicationsData });
    if (update == true) submitData({ ...data, medicalConditions: medicationsData }, dispatch, history);
  };

  React.useEffect(() => {
    saveChangesState[1](() => saveChanges);
  }, [medications, data]);

  //React.useEffect(() => {
  //    if (data.medicalConditions) setMedications(data.medicalConditions);
  //    if (data.MedicalConditions) setMedications(data.MedicalConditions);
  //}, [data])

  const validateForOxygen = () => {
    let medicationData = [...medications];
    let hasMedications = medicationData.some((e) => e.name !== "" && e.name !== null && e.dateAndTime !== null);
    if (data.isOxygenRequired && !hasMedications) {
      setErrorMessage("You have indicated that Oxygen will be required on transport. Please enter details of oxygen administered.");
      return false;
    }
    return true;
  };

  const onNextButtonClick = async (): Promise<boolean> => {
    if (!validateForOxygen()) return false;
    const isValid = medications.length === 0 || !medications.some((e) => e.errors !== undefined && Object.keys(e.errors).length > 0);
    if (isValid) {
      await handleNext();
    }
    return isValid;
  };
  const setTimeValue = (index: number, date: MaterialUiPickersDate, value: string | null | undefined): void => {
    let items = [...medications];
    let item = { ...items[index] };
    let dateUtil = new DateFnsUtils();
    item.dateAndTime = date && !isNaN(date.getTime()) ? dateUtil.format(date, "yyyy-MM-dd'T'HH:mm:ss") : null;
    item.dateAndTimeObject = date;
    items[index] = item;
    validateRow(item);
    setMedications(items);
    setErrorMessage("");
  };

  const onChangeField = (index: number, fieldName: string, value: string) => {
    let items = [...medications];
    let item = { ...items[index] };
    if (fieldName === "name") {
      item.name = value;
    } else if (fieldName === "dose") {
      item.dose = value;
    } else if (fieldName === "route") {
      item.route = Number(value);
    } else if (fieldName === "unit") {
      item.unit = Number(value);
    }
    items[index] = item;
    validateRow(item);
    setMedications(items);
    setErrorMessage("");
  };

  const onChangeMedicationField = (index: number, value: { name: string | null; monographId: string | null; brandId: string | null; monographType: string | null }) => {
    let items = [...medications];
    let item = {
      ...items[index],
      name: value.name,
      monographId: value.monographId,
      brandId: value.brandId,
      monographType: Number(value.monographType),
    };
    items[index] = item;
    validateRow(item);
    setMedications(items);
    setErrorMessage("");
  };

  const addMedication = () => {
    let items = [...medications];
    items.push({ dateAndTime: null, dateAndTimeObject: null, name: null });
    setMedications(items);
  };

  const validateRow = (item: MedicationInternal) => {
    if ((item.name !== null && item.name !== "") || item.dateAndTimeObject !== null || (item.dose !== "" && item.dose !== undefined) || item.route !== undefined || item.unit !== undefined) {
      if (item.errors === undefined) item.errors = {};
      if (item.name === null || item.name === "") {
        item.errors["name"] = "Required";
      } else {
        delete item.errors["name"];
      }

      if (item.dateAndTime === null) {
        item.errors["dateAndTime"] = "Required";
      } else {
        delete item.errors["dateAndTime"];
      }
    } else {
      item.errors = undefined;
    }
  };

  const deleteMedication = (index: number) => {
    var updatedMedications = [...medications];
    if (index > -1) {
      updatedMedications.splice(index, 1);
    }
    setMedications([...updatedMedications]);
  };
  return (
    <React.Fragment>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={3} alignItems="flex-start" alignContent="flex-start" style={{ height: "fit-content", paddingTop: 40 }}>
          <Grid item xs={6}>
            <Typography style={{ fontSize: 36, fontWeight: 900, wordBreak: "break-word" }}>Medications & Blood Products</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            {!isEdit && <NextButton onClick={onNextButtonClick} />}
            <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
            <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
          </Grid>

          <Grid container spacing={3} style={{ marginTop: 20 }}>
            <Grid className={classes.medicationRow} container spacing={3}>
              <Grid item xl={2} lg={3} xs={4}>
                <div className={classes.formControlLabel}>DATE AND TIME</div>
              </Grid>
              <Grid item xl={3} lg={3} xs={2}>
                <div className={classes.formControlLabel}>NAME</div>
              </Grid>
              <Grid item xs={1}>
                <div className={classes.formControlLabel}>DOSE</div>
              </Grid>
              <Grid item xs={2}>
                <div className={classes.formControlLabel}>UNIT</div>
              </Grid>
              <Grid item xs={2}>
                <div className={classes.formControlLabel}>ROUTE</div>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
            {medications.map((medication, index) => {
              return (
                <React.Fragment key={index}>
                  <Grid className={classes.medicationRow} container spacing={3}>
                    <Grid item xl={2} lg={3} xs={4}>
                      <KeyboardDateTimePicker
                        disableFuture={true}
                        InputProps={{
                          style: { fontSize: 16 },
                        }}
                        format="dd/MM/yyyy HH:mm"
                        placeholder="dd/mm/yyyy HH:mm"
                        ampm={false}
                        key={"dateAndTime" + index}
                        inputVariant="outlined"
                        initialFocusedDate={null}
                        style={{
                          marginTop: 3,
                        }}
                        invalidDateMessage="Invalid"
                        value={medication.dateAndTimeObject}
                        onChange={(date, value) => {
                          setTimeValue(index, date, value);
                        }}
                        DialogProps={{
                          className: classes.dateTimePicker,
                        }}
                      />
                      <FormHelperText className={classes.helpText}>{medication.errors !== undefined && medication.errors.dateAndTime !== undefined ? medication.errors.dateAndTime : ""}</FormHelperText>
                    </Grid>
                    <Grid item xl={4} lg={3} xs={2}>
                      <MedicationAutocomplete
                        id={"id" + index}
                        key={"Name" + index}
                        SetMedname={{}}                      
                        InputProps={{}}
                        value={medication.name}
                        isError={medication.errors !== undefined && medication.errors.name !== undefined}
                        helperText={medication.errors !== undefined && medication.errors.name !== undefined ? medication.errors.name : ""}
                        passSelection={(newValue: string, brandId: string | null, monographId: string | null, monographType: string | null) => {
                          onChangeMedicationField(index, {
                            name: newValue,
                            brandId: brandId,
                            monographId: monographId,
                            monographType: monographType,
                          });
                        }}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <TextField
                        style={{ marginTop: 3 }}
                        value={medication.dose}
                        key={"Dose" + index}
                        variant="outlined"
                        onChange={(e: any) => {
                          onChangeField(index, "dose", e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Select
                        key={"Unit" + index}
                        fullWidth={true}
                        value={String(medication.unit ?? "")}
                        variant="outlined"
                        displayEmpty
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        onChange={(e: any) => {
                          onChangeField(index, "unit", e.target.value);
                        }}
                      >
                        <MenuItem key="None" value={""}>
                          --Choose--
                        </MenuItem>
                        {medicationUnits.map((item) => (
                          <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={2}>
                      <Select
                        key={"Route" + index}
                        fullWidth={true}
                        value={String(medication.route ?? "")}
                        variant="outlined"
                        displayEmpty
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        onChange={(e: any) => {
                          onChangeField(index, "route", e.target.value);
                        }}
                      >
                        <MenuItem key="None" value={""}>
                          --Choose--
                        </MenuItem>
                        {medicationRoutes.map((item) => (
                          <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton onClick={() => deleteMedication(index)} style={{ padding: 5, color: "red" }} component="span">
                        <DeleteForeverIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
          <Grid container spacing={3} alignItems="flex-start" style={{ marginTop: 20 }}>
            <Button color="default" onClick={addMedication} style={{ paddingLeft: 20, color: "#0049A3", fontSize: 18 }} startIcon={<AddIcon />}>
              Add Another Medication
            </Button>
          </Grid>

          <div className={classes.headingAlert}>
            <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" style={{ display: errorMessage ? "flex" : "none" }}>
              {errorMessage}
            </Alert>
          </div>
        </Grid>
      </MuiPickersUtilsProvider>
    </React.Fragment>
  );
};

export default Medications;
